import { MapPin } from 'lucide-react';
import { fmtKc } from './k2utils';
import { fmtQty } from './itemsUtils';

export function groupByLocation(items) {
  const map = new Map();
  items.forEach((x) => {
    const loc = x.location || 'Bez umístění';
    if (!map.has(loc)) map.set(loc, { loc, count: 0, value: 0, units: {} });
    const g = map.get(loc);
    g.count += 1;
    g.value += x.value;
    const u = x.unit || '';
    g.units[u] = (g.units[u] || 0) + x.quantity;
  });
  return [...map.values()].sort((a, b) => b.value - a.value);
}

const Tile = ({ g, total, active, onClick }) => {
  const share = total ? (g.value / total) * 100 : 0;
  const units = Object.entries(g.units).sort((a, b) => b[1] - a[1]);
  return (
    <button type="button" onClick={onClick} data-testid={`k2-nes-loc-${g.loc}`}
      className={`text-left p-4 rounded-xl border transition-colors ${active ? 'border-[#16A34A] bg-[#F0FDF4] ring-1 ring-[#16A34A]' : 'border-[#E2E8F0] bg-[#F8FAF8] hover:border-[#86EFAC]'}`}>
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[#57534E]">
        <MapPin className="w-4 h-4 text-[#F59E0B]" /> {g.loc}
      </div>
      <div className="mt-1 text-xl font-bold text-[#052E16] font-['Manrope'] tabular-nums" data-testid={`k2-nes-loc-${g.loc}-value`}>{fmtKc(g.value)}</div>
      <div className="text-xs text-[#57534E] mt-0.5" data-testid={`k2-nes-loc-${g.loc}-count`}>
        {g.count} položek · {units.map(([u, q]) => fmtQty(q, u)).join(' · ')}
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-[#E2E8F0] overflow-hidden">
        <div className="h-full bg-[#F59E0B]" style={{ width: `${share}%` }} />
      </div>
      <div className="text-[11px] text-[#94A3B8] mt-1">{share.toFixed(1)} % hodnoty skladu</div>
    </button>
  );
};

export const NesLocationTiles = ({ items, active, onSelect }) => {
  const groups = groupByLocation(items);
  const total = groups.reduce((a, g) => a + g.value, 0);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="k2-nes-loc-tiles">
      {groups.map((g) => (
        <Tile key={g.loc} g={g} total={total} active={active === g.loc} onClick={() => onSelect(active === g.loc ? null : g.loc)} />
      ))}
    </div>
  );
};
